import * as bootstrap from 'bootstrap';

export class DevelopmentHelpers {
  convert = new ConversionHelpers();
  guid = new GUIDHelpers();
  
  monthSelectorArray(language) {
    let format = new Intl.DateTimeFormat(language, { month: 'long' });
    let months = [];
    for (let i = 0; i < 12; i++) {
      let date = new Date(2000, i, 1);
      months.push({ number: i, name: format.format(date) })
    }
    return months;
  }
  
  splitAddress(a) {
    let address = a.includes(',') ? a.split(',')[0] : a;
    let city = a.includes(',') ? a.split(',')[1].replace(/\d+/, '').trim() : a;
    let zip = a.includes(',') ? a.split(',')[1].replace(/[^\d ]/g, '').trim() : a;
    return {address:address, zipCode: zip, city: city}
  }

  addTwoObjectsWithNumbers(a:object,b:object){
    let c = {}
    for(let x of Object.keys(a)){
      c[x] = a[x] + b[x]
    }
    return c
  }

  modal(id:string) {
    console.log(document.getElementById(id))
    let a = new bootstrap.Modal(document.getElementById(id))
    console.log(a.isShown, a._isShown)
    a.toggle();
  }
}

export class ConversionHelpers {
  lookupDictionaryFromArrayOfObjects(data: Array<any>, key: string, value: string) {
    return Object.assign({}, ...data.map((x) => ({ [x[key]]: x[value] })))
  }
  offerStatusLookup = {
    'bee21fe3-503e-4a8b-8ac4-030929c87741': 'Offers.AwaitingAccept',
    'e65f9d9e-34b2-4423-8ad4-7228db8814b4': 'Offers.Rejected',
    'a1a453b8-6ae7-453d-bfdb-867ace78654e': 'Offers.Accepted',
    'f833a8c3-2944-4a3d-a9b3-8faa01156485': 'Offers.New',
    'dc604f52-769c-4568-88f5-b77ff41ad95e': 'Offers.AwaitingReply',
    '8bfc347c-40c4-42ca-93fc-f4d651c0a109': 'Offers.Pipeline'
  }
  async getClassFromObject(object:Object,name):Promise<StringClass>{
    let string = 'interface ' + name + ' {\n';
    let classes = {}
    let keys = Object.keys(object).sort((a,b)=> a.toLowerCase() < b.toLowerCase() ? -1 : 1);
    for (let x of keys ){
      if(this.isNull(object[x])) {
        string = string + '\t'+ this.firtCharToLowerCase(x) + ':undefined;\n'
      }
      else if(this.isArray(object[x])) {
        // console.log(x, typeof(object[x]),Object.prototype.toString.call(object[x]))
        let newArray = await this.getClassFromArray(object[x],x);
        console.log(x,newArray)
        string = string + newArray.string;
        classes = {...classes, x:newArray.classes[x]}
      }
      else if(this.isObject(object[x])) {
        let newObject = await this.getClassFromObject(object[x],x);
        console.log(x,newObject)
        classes = {...classes, x:newObject.classes[x]}
        string = string + '\t'+ this.firtCharToLowerCase(x) + ':' + x + ';\n'
        classes[x] = newObject.string;
      }
      else string = string + '\t'+ this.firtCharToLowerCase(x) + ':' + typeof(object[x]) + ';\n'
    }
    string = string + '\n}'
    return {string:string, classes:classes}
  }
  async getClassFromArray(arr:Array<any>,name:string):Promise<StringClass>{
    let string = '';
    let classes = {};
    let a = arr[0];
    // console.log(name,typeof(a))
    if(!a){
      string = string + '\t'+ this.firtCharToLowerCase(name) + ':' + typeof(a) + '[];\n'
    }
    else if(this.isArray(a)) {
      let newArray = await this.getClassFromArray(a,name);
      string = string + newArray.string;
      classes = {...classes, x:newArray.classes}
    }
    else if(this.isObject(a)) {
      let newObject = await this.getClassFromObject(a,name);
      classes = {...classes, x:newObject.classes}
      string = string + '\t'+ this.firtCharToLowerCase(name) + ':' + name + '[];\n'
      classes[name] = newObject.string;
    }
    else string = string + '\t'+ this.firtCharToLowerCase(name) + ':' + typeof(a) + '[];\n'
    return {string:string, classes:classes}
  }
  isNull(data) {return Object.prototype.toString.call(data) === '[object Null]'}
  isArray(data) { return Object.prototype.toString.call(data) === '[object Array]' }
  isObject(data) { return Object.prototype.toString.call(data) === '[object Object]' }
  firtCharToLowerCase(s:string) {
    return s[0].toLowerCase() + s.slice(1,s.length);
  }

}

interface StringClass {
  string:string;
  classes:object;
}

export class GUIDHelpers {
  private guidPart() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  newGUID() {
    return (this.guidPart() + this.guidPart() + "-" + this.guidPart() + "-4" + this.guidPart().slice(0, 3) + "-" + this.guidPart() + "-" + this.guidPart() + this.guidPart() + this.guidPart()).toLowerCase();
  }
  async newGUIDarray(amount: number) {
    let a = [];
    for (let i = 0; i < amount; i++) {
      a.push(this.newGUID())
    }
    return a
  }
}

export class ClickPreventer {
  lastClicked: Date = null;
  clickDelayInMs: number = 700;
  clickAllowed(){
    if(!this.lastClicked || this.lastClicked.getTime() + this.clickDelayInMs < new Date().getTime()){ 
      this.lastClicked = new Date()
      return true 
    }
    else {
      return false
    }
  }
}